import { formatOrder } from '../../../models/filter';

export default {
  computed: {
    optionFormats() {
      let formats = this.product.variants.map((v) => {
        const option = v.options.find((o) => o.name === 'Format');
        if (option) {
          return option.value;
        }
        return null;
      });
      if (formats.every((f) => f === null)) {
        return [''];
      }
      formats = formats.filter((f, i, a) => f !== null && a.indexOf(f) === i);
      return formats.slice().sort((a, b) => formatOrder.indexOf(a) - formatOrder.indexOf(b));
    },
  },
  methods: {
    getOptionValue(name, variant = this.variant) {
      const option = variant.options.find((o) => o.name === name);
      if (option) {
        return option.value;
      }
      return null;
    },
    getVariantsByFormat(format) {
      if (format === '') {
        return this.product.variants;
      }
      return this.product.variants.filter((v) => v.options.find((o) => o.name === 'Format' && o.value === format));
    },
    getSortedVariantsByFormat(format) {
      return this.getVariantsByFormat(format).slice().sort((a, b) => {
        const val1 = this.getOptionValue('Conditionnement', a);
        const val2 = this.getOptionValue('Conditionnement', b);
        const firstCondUnit = this.getConditionnementUnit(val1);
        const secondCondUnit = this.getConditionnementUnit(val2);
        const firstCondNumber = this.getConditionnementNumber(val1);
        const secondCondNumber = this.getConditionnementNumber(val2);
        const units = this.getSortedUnitList();
        const result = units.indexOf(firstCondUnit) - units.indexOf(secondCondUnit);
        if (result === 0) {
          return firstCondNumber - secondCondNumber;
        }
        return result;
      });
    },
    getConditionnementNumber(value) {
      let numberPart = value.replace(/[^0-9.,]/g, '');
      numberPart = numberPart.replace(/,/g, '.');
      return parseFloat(numberPart);
    },
    getConditionnementUnit(value) {
      return value.replace(/[0-9., ]/g, '');
    },
    getSortedUnitList() {
      return ['µg', 'µl', 'mg', 'ml'];
    },
  },
};
